<table cdk-table [dataSource]="structure" multiTemplateDataRows class="table pagetable">
    <ng-container cdkColumnDef="showCollapse">
        <th cdk-header-cell *cdkHeaderCellDef> </th>
        <td cdk-cell *cdkCellDef="let instrument" class="row-toggle">
            @if (instrument.showCollapse === 'collapse') {
            <i-bs [name]="iconNames.ChevronDown" [@openClose]="isExpanded[instrument.instrument_id] ? 'open' : 'closed'" class="d-inline-block"></i-bs>
            }
        </td>
    </ng-container>

    <ng-container cdkColumnDef="instrument_name">
        <th cdk-header-cell *cdkHeaderCellDef> Instrument Name </th>
        <td cdk-cell *cdkCellDef="let instrument" class="instrument-name">
            {{ instrument.instrument_name }}
        </td>
    </ng-container>
    <ng-container cdkColumnDef="instrument_type">
        <th cdk-header-cell *cdkHeaderCellDef> Type </th>
        <td cdk-cell *cdkCellDef="let instrument">
            {{ instrument.instrument_type }}
        </td>
    </ng-container>
    <ng-container cdkColumnDef="instrument_sub_type">
        <th cdk-header-cell *cdkHeaderCellDef> Sub-Type </th>
        <td cdk-cell *cdkCellDef="let instrument">
            {{ instrument.instrument_sub_type }}
        </td>
    </ng-container>
    <ng-container cdkColumnDef="instrument_security">
        <th cdk-header-cell *cdkHeaderCellDef> Security Priority </th>
        <td cdk-cell *cdkCellDef="let instrument">
            {{ instrument.instrument_security }}
        </td>
    </ng-container>
    <ng-container cdkColumnDef="instrument_priority">
        <th cdk-header-cell *cdkHeaderCellDef> Security Level </th>
        <td cdk-cell *cdkCellDef="let instrument">
            {{ instrument.instrument_priority }}
        </td>
    </ng-container>
    <ng-container cdkColumnDef="instrument_maturity_date">
        <th cdk-header-cell *cdkHeaderCellDef> Maturity Date </th>
        <td cdk-cell *cdkCellDef="let instrument">
            @if (instrument.instrument_maturity_date.length >= 10 ) {
                {{ instrument.instrument_maturity_date | date }}
            } @else {
                {{ instrument.instrument_maturity_date }}
            }
        </td>
    </ng-container>
    <ng-container cdkColumnDef="interest_rates">
        <th cdk-header-cell *cdkHeaderCellDef class="text-center"> Interest Rate </th>
        <td cdk-cell *cdkCellDef="let instrument" class="text-center">
            {{ instrument.interest_rates }}
        </td>
    </ng-container>
    <ng-container cdkColumnDef="instrument_amount">
        <th cdk-header-cell *cdkHeaderCellDef class="text-end"> Issuance Principal Amount </th>
        <td cdk-cell *cdkCellDef="let instrument" class="text-end">
            <ng-container
                *ngTemplateOutlet="instrumentAmount; context: {amount: instrument.instrument_amount, currency: instrument.instrument_amount_currency, parent: instrument.instrument_linked_instruments_parent, linked: instrument.instrument_amount_linked_instruments ?? [], instrumentIDLookup: instrumentIDLookup}">
            </ng-container>
        </td>
    </ng-container>
    <ng-container cdkColumnDef="price">
        <th cdk-header-cell *cdkHeaderCellDef class="text-end"> Price </th>
        <td cdk-cell *cdkCellDef="let instrument" class="text-end text-nowrap">
            {{ instrument.price | currency: instrument.instrument_amount_currency }}
            @if (instrument.priceDelta == 'increase') {
                <i-bs [name]="iconNames.CaretUpFill" class="d-inline-block" style="color: #0f0"></i-bs>
            } @else if (instrument.priceDelta == 'decrease') {
                <i-bs [name]="iconNames.CaretDownFill" class="d-inline-block" style="color: #f00"></i-bs>
            }
        </td>
    </ng-container>
    <ng-container cdkColumnDef="yield">
        <th cdk-header-cell *cdkHeaderCellDef class="text-end"> Yield </th>
        <td cdk-cell *cdkCellDef="let instrument" class="text-end">
            @if (instrument.yield) {
                @if (instrument.yield <= 0) {
                    N/A
                } @else {
                {{instrument.yield | number: '1.0-2' }}%
                }
            }
        </td>
    </ng-container>
    <ng-container cdkColumnDef="instrument_outstanding_amount">
        <th cdk-header-cell *cdkHeaderCellDef class="text-end"> Outstanding Principal Amount </th>
        <td cdk-cell *cdkCellDef="let instrument" class="text-end">
            <ng-container
                *ngTemplateOutlet="instrumentAmount; context: {amount: instrument.instrument_outstanding_amount, currency: instrument.instrument_outstanding_amount_currency, parent: instrument.instrument_outstanding_amount_linked_instruments_parent, linked: instrument.instrument_outstanding_amount_linked_instruments ?? [], instrumentIDLookup: instrumentIDLookup}">
            </ng-container>
        </td>
    </ng-container>
    <ng-container cdkColumnDef="instrument_outstanding_amount_info">
        <th cdk-header-cell *cdkHeaderCellDef class="text-end"> </th>
        <td cdk-cell *cdkCellDef="let instrument" class="px-0">
            <ng-template #amountTemplate>
                <ul class="list-unstyled bg-white text-dark">
                    <li>
                        <strong>Interest/Fees Included:</strong> {{ instrument.instrument_outstanding_included_interest_fees }}
                    </li>
                    @if (instrument.instrument_outstanding_included_interest_fees !== 'Yes' && instrument.instrument_interest_fees > 0) {
                    <li>
                        Interest and Fees: {{ instrument.instrument_interest_fees | currency: instrument.instrument_outstanding_amount_currency }}
                    </li>
                    }
                </ul>
            </ng-template>
            @if (instrument.instrument_outstanding_amount > 0) {

            @if (instrument.instrument_outstanding_amount > 0 && (instrument.instrument_outstanding_amount_linked_instruments.length == 0 || instrument.instrument_outstanding_amount_linked_instruments_parent == 'Yes') &&
            instrument.instrument_outstanding_included_interest_fees == 'Yes' || (instrument.instrument_outstanding_included_interest_fees == 'No' && instrument.instrument_interest_fees > 0)) {
            <i-bs [name]="iconNames.InfoCircle" [ngbTooltip]="amountTemplate" placement="top" adaptivePosition="false" container="body" containerClass="white-tooltip"></i-bs>
            }

            }
        </td>
    </ng-container>

    <ng-container cdkColumnDef="expandedDetail">
        <td cdk-cell *cdkCellDef="let instrument" class="pt-2 border-left border-right border-bottom rounded-bottom pb-2" [attr.colspan]="20">
            @if (expandAll || isExpanded[instrument.instrument_id]) {
            <div @expandCollapse>
                <app-instrument-view [instrument]="instrument" [instrumentIDLookup]="instrumentIDLookup" [classesLookup]="classesLookup" class="collapsible w-100" [expandAll]="expandAll"  [canShowFactSetData]="true"></app-instrument-view>
            </div>
            }
        </td>
    </ng-container>
    <tr cdk-header-row *cdkHeaderRowDef="columns"></tr>
    <tr cdk-row *cdkRowDef="let instrument; columns: columns;" [class.clickable]="instrument.showCollapse === 'collapse'" (click)="isExpanded[instrument.instrument_id] = ! isExpanded[instrument.instrument_id]"
        [attr.aria-expanded]="isExpanded[instrument.instrument_id]" class="hover"></tr>

    <!-- Extra row to show detail content column -->
    <tr cdk-row *cdkRowDef="let instrument; columns: ['expandedDetail']" #collapse="ngbCollapse" [ngbCollapse]="!isExpanded[instrument.instrument_id]" (ngbCollapseChange)="isExpanded[instrument.instrument_id] = $event" [attr.aria-labelledby]="'collapse-' + instrument.instrument_id"></tr>
</table>

<ng-template #instrumentAmount let-amount="amount" let-currency="currency" let-parent="parent" let-linked_instruments="linked" let-instrumentIDLookup="instrumentIDLookup">
    @if ((amount > 0 || amount === '0') && (linked_instruments?.length == 0 || parent == 'Yes')) {

    {{ amount | currency: currency }}
    <ng-template #sharedTemplate>
        <ul class="list-unstyled bg-white text-dark">
            <li>
                <strong>Declared with:</strong>
            </li>
            @for (linked of linked_instruments; track linked) {
            <li>
                {{ instrumentIDLookup[linked] }}
            </li>
            }
        </ul>
    </ng-template>
    @if (linked_instruments?.length) {

    <i-bs i-bs [name]="iconNames.ExclamationTriangle" [ngbTooltip]="sharedTemplate" placement="top" adaptivePosition="false" container="body" containerClass="white-tooltip"></i-bs>

    }

    }
</ng-template>

<ng-template #linkedIn let-linkedin="linkedin">
    <linked-in [handle]="linkedin"></linked-in>
</ng-template>

<ng-template #displayContact let-contact="contact">
    <ul class="list-unstyled">
        <li><a target="_blank" href="{{contact.url}}">{{ contact.entity_name }}</a></li>
        @if (contact.telephone) {
        <li><a target="_blank" href="tel:{{contact.telephone}}"><i-bs [name]="iconNames.TelephoneOutbound"></i-bs>&nbsp;{{contact.telephone | phone:'US'}}</a></li>
        }
        @if (contact.email) {
        <li><a target="_blank" href="email:{{contact.email}}"><i-bs [name]="iconNames.EnvelopeAt"></i-bs>&nbsp;{{contact.email}}</a></li>
        }
        @if (contact.web) {
        <li><a target="_blank" [href]="contact.web"><i-bs [name]="iconNames.BrowserChrome"></i-bs>&nbsp;Website</a></li>
        }
        @if (contact.linkedin?.length > 10) {
        <li>
            <a target="_blank" [href]="contact.linkedin" [ngbPopover]="linkedIn" [popoverContext]="{linkedin : getLinkedInHandle(contact.linkedin)}" popoverClass="linkedin-popover" triggers="mouseenter" [autoClose]="'outside'" [openDelay]="200">
                <i-bs [name]="iconNames.Linkedin"></i-bs>&nbsp;LinkedIn
            </a>
        </li>
        }
    </ul>
</ng-template>